module.exports = __webpack_public_path__ + "img/caseimeiopposmall.66f94b82.png";